import classNames from "classnames"
import { ToggleButton } from "common/form/ToggleButton"
import { completionLabel, completionToDb, isCompleted } from "utils/evoTripsUi"

type Props = {
  /** Unique per row — duplicate ids make every toggle control the first row */
  rowId: string
  status?: string
  disabled?: boolean
  onChange: (status: "Paid" | "Not-Paid") => void
}

export const CompletionStatusControl = ({
  rowId,
  status,
  disabled,
  onChange,
}: Props) => {
  const completed = isCompleted(status)
  const label = completionLabel(status)

  return (
    <div className="flex items-center gap-2">
      <span
        className={classNames(
          "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium tracking-wide",
          completed
            ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200"
            : "bg-red-50 text-red-700 ring-1 ring-red-200"
        )}
      >
        <span
          className={classNames("w-1.5 h-1.5 rounded-full", {
            "bg-emerald-500": completed,
            "bg-red-500": !completed,
          })}
        />
        {label}
      </span>
      <ToggleButton
        value={completed}
        disabled={disabled}
        id={`completion-${rowId}`}
        onChange={(e) => onChange(completionToDb(e.target.checked))}
      />
    </div>
  )
}
